/**
 * Scan POS latency R1 -- the Website half of the timing evidence.
 *
 * Off unless this browser opted in:
 *     localStorage.setItem('jinda_pos_scan_timing', '1')
 * (Scan POS itself only runs against Staging -- see realtime-config.ts.)
 *
 * When on, one console line per processed frame:
 *     scan_timing outcome=APPLIED source=LOCAL queued_ms=0 lookup_ms=0 mutate_ms=1 cart_ms=1 ack_ms=640 total_ms=641
 * and the last 100 are kept in `window.__jindaScanTimings` for collection.
 * Numbers and categories only: the receiver never hands this a barcode, an
 * event id or a surface id.
 */
import { FastTiming } from './fast-barcode-receiver';
import { ScanTiming } from './receiver';

type AnyTiming = ScanTiming | FastTiming;

export const SCAN_TIMING_FLAG = 'jinda_pos_scan_timing';
const KEEP = 100;

const enabled = (): boolean => {
    try {
        return typeof window !== 'undefined' && window.localStorage.getItem(SCAN_TIMING_FLAG) === '1';
    } catch {
        return false;
    }
};

const FIELDS: Array<[string, string]> = [
    ['queuedMs', 'queued_ms'], ['lookupMs', 'lookup_ms'], ['mutateMs', 'mutate_ms'],
    ['cartMs', 'cart_ms'], ['ackMs', 'ack_ms'], ['totalMs', 'total_ms'],
];

export const formatScanTiming = (t: AnyTiming): string => {
    const parts = [`outcome=${t.outcome}`];
    if ((t as FastTiming).path === 'FAST') parts.unshift('path=FAST');
    if (t.source) parts.push(`source=${t.source}`);
    for (const [key, label] of FIELDS) {
        const value = (t as any)[key];
        if (typeof value === 'number') parts.push(`${label}=${value}`);
    }
    if (typeof (t as FastTiming).ackSent === 'boolean') parts.push(`ack_sent=${(t as FastTiming).ackSent ? 1 : 0}`);
    return `scan_timing ${parts.join(' ')}`;
};

export const reportScanTiming = (t: AnyTiming): void => {
    if (!enabled()) return;
    const w = window as any;
    const kept: AnyTiming[] = Array.isArray(w.__jindaScanTimings) ? w.__jindaScanTimings : [];
    kept.push({ ...t });
    while (kept.length > KEEP) kept.shift();
    w.__jindaScanTimings = kept;
    console.info(formatScanTiming(t));
};
